import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFetch } from '../../../../hooks/useFetch';
import ShowAt from '../../../Common/ShowAt/ShowAt';
import './NFTImage.scss';

const nftMetaUrl = '/champion/nft';

export default function NFTImage({ nftId, img, loading }) {
  const params = new URLSearchParams({ nft_id: nftId, chain_id: window.chainId }).toString();
  const url = [nftMetaUrl, params].join('?');
  const [getNftMeta, nftRes, _loading, , initRender] = useFetch(url);
  const mergedLoading = [loading, _loading].some((__loading) => __loading);
  const nftImage = img || nftRes?.nft?.image_s3;
  const noImage = !mergedLoading && !nftImage;

  useEffect(() => {
    if (!Number.isInteger(nftId) || !initRender || img) return;
    getNftMeta();
  }, [nftId, initRender]);
  return (
    <>
      <ShowAt at={noImage}>
        <div className="no-img-placeholder" />
      </ShowAt>
      <ShowAt at={!!nftImage}>
        <img src={nftImage || img} alt="" />
      </ShowAt>
    </>
  );
}

NFTImage.defaultProps = {
  nftId: null,
  img: null,
  loading: false,
};

NFTImage.propTypes = {
  nftId: PropTypes.number,
  img: PropTypes.string,
  loading: PropTypes.bool,
};
